import { familyHistoryApi } from 'Api/familyHistory';
import TimeLineBaseUI from 'components/Shared/TimeLineBaseUI';
import { useSearchParams } from 'react-router-dom';
import { toastText } from 'utils/utils';

const FamilyHistoryView = () => {
	const [searchParams] = useSearchParams();
	const employeeId = searchParams.get('employeeId');

	if (!employeeId) {
		return null;
	}

	const fetchMembers = async (params: {
		search?: string;
		status?: 'Alive' | 'Deceased' | 'all';
		sort?: 'most_recent';
		limit: number;
		offset: number;
	}) => {
		try {
			const response = await familyHistoryApi.getFamilyMembers(employeeId, params);
			return {
				data: response?.data?.data || [],
				total: response?.data?.total || 0,
			};
		} catch (error: any) {
			toastText(
				error?.response?.data?.message || 'Failed to fetch family members',
				'error'
			);
			return { data: [], total: 0 };
		}
	};

	return <TimeLineBaseUI readOnly fetchMembers={fetchMembers} />;
};

export default FamilyHistoryView;
